module.exports = __webpack_public_path__ + "images/5608d72c0aa53769131941b8ca6aad2c.png";